<template>
  <div>
    <van-skeleton title animate :row="12" :round="true" :loading="loading_ske">
      <div class="tag01">
        标签管理
      </div>
      <div class="tag02">
        <el-tag
          :key="index"
          v-for="(item,index) in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(item,index)">
          {{item.name}}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签</el-button>
      </div>
    </van-skeleton>
  </div>
</template>

<script>
  import util from "../../util/util";
  import httpLab from '@/api/label';
  var me;
  var user;
  var menu;
  export default {
    name: "list",
    data(){
      return {
        loading_ske:true,             //骨架屏显示
        dynamicTags: [],
        inputVisible: false,
        inputValue: '',
        page:1,
        pageSize:200
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      menu = JSON.parse(sessionStorage.getItem('menu'));
    },
    mounted() {
      let datas = {
        mobile:user.mobile,
        sign:user.sign,
        companyId:user.companyId,
        page:1,
        pageSize:me.pageSize
      }
      httpLab.labelList(datas).then(res => {
        me.dynamicTags = res.data.dataList;
        me.loading_ske = false;
      })
    },
    methods:{
      handleClose(item,index) {
        let is_auth = util.is_Auth(menu,'用户管理','删除标签');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$confirm('此操作将删除该标签, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          me.$Loading.start();
          let data = {
            mobile:user.mobile,
            sign:user.sign,
            companyid:user.companyId,
            method:'del',
            id:item.id
          };
          httpLab.addLabel(data).then(res => {
            switch (res.code) {
              case '0000':
                me.dynamicTags.splice(index,1);
                me.$message.success('删除成功');
                me.$Loading.finish();
                break;
              case '1111':
                me.$message.error('删除失败');
                me.$Loading.error();
                break;
            }
          })
        })
        // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      handleInputConfirm() {
        let is_auth = util.is_Auth(menu,'用户管理','添加标签');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        let inputValue = this.inputValue;
        if (!util.isSpace(inputValue) && inputValue != '') {
          if (inputValue.length > 5) {
            me.$message.error('标签名称不能超过五位数');
            return false;
          }
          me.$Loading.start();
          let data = {
            mobile:user.mobile,
            sign:user.sign,
            companyid:user.companyId,
            name:inputValue,
            method:'addorupdate'
          }
          httpLab.addLabel(data).then(res => {
            console.log(res);
            switch (res.code) {
              case "0000":
                let datas = {
                  mobile:user.mobile,
                  sign:user.sign,
                  companyId:user.companyId,
                  page:1,
                  pageSize:me.pageSize
                }
                httpLab.labelList(datas).then(res => {
                  me.dynamicTags = res.data.dataList;
                })
                me.$message.success('添加成功');
                me.$Loading.finish();
                break;
              case "1111":
                me.$message.error('添加失败');
                me.$Loading.error();
                break;
            }
          })
        }
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
  }
</script>

<style scoped>
@import "style.css";
</style>